<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          v-bind="attrs"
          color="grey darken-1"
          v-on="on"
        >
          mdi-information
        </v-icon>
      </template>
      <span>
        Sinoa is designed to provide grain market insights and help you make sense of market trends.
        While it can give helpful context, its answers may not always be complete or up to date.
        Please don't rely on it as your only source when making important marketing or financial decisions.
        <br>
        For decisions about your farm or business, be sure to confirm information with trusted advisors or
        professionals. GrainFox isn't responsible for actions taken solely based on Sinoa's responses
      </span>
    </v-tooltip>

    <v-btn
      text
      :icon="$isMobile"
      :disabled="isSinoaLoading"
      @click="$emit('toggle-history')"
    >
      <v-icon v-if="$isMobile">
        mdi-history
      </v-icon>
      <span v-else>
        {{ showingHistory ? 'HIDE HISTORY' : 'HISTORY' }}
      </span>
    </v-btn>

    <v-btn
      icon
      @click="$emit('toggle-fullscreen')"
    >
      <v-icon>{{ fullScreen ? 'mdi-arrow-collapse' : 'mdi-arrow-expand' }}</v-icon>
    </v-btn>

    <v-btn
      icon
      @click="$emit('close-dialog')"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { COLORS } from '@/helpers/colors';
import { mapGetters } from 'vuex';

export default {
  name: 'SinoaActions',

  props: {
    fullScreen: {
      type: Boolean,
      default: false,
    },

    showingHistory: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      COLORS,
    };
  },

  computed: {
    ...mapGetters('chatbot', ['isSinoaLoading']),
  },
};
</script>
